<div class="panel expander collapsed" #addNotePanel>
	<div class="heading" (click)="$event.target.parentElement.classList.toggle('collapsed')">Create a new note</div>
	<div class="content">
		<form>
			<div class="mb-3 row">
				<label class="col-md-2">Title:</label>
				<div class="col-md-10">
					<input [(ngModel)]="newLog.editTitle" name="editTitle" type="text" maxlength="64" class="form-control">
				</div>
			</div>
			<div class="mb-3">
				<div class="mb-2">Details:</div>
				<textarea [(ngModel)]="newLog.editContent" name="editContent" rows="10" class="form-control"></textarea>
			</div>
			<div class="mb-3 row">
				<div class="col-md-8 offset-md-4">
					<app-action-button submit [action]="SaveLog" [context]="this" [args]="[newLog]" processing="Saving..." complete="Log saved" btnClass="block">Save
					</app-action-button>
				</div>
			</div>
		</form>
	</div>
</div>
@if (adminLogs && adminLogs.length === 0) {
	<div>No notes for this asset</div>
}
@if (adminLogs && adminLogs.length > 0) {
	<table class="log">
		<tbody>
			<tr>
				<th></th>
				<th>Date</th>
				<th>Entered by</th>
				<th>Summary</th>
				<th>Delete</th>
			</tr>
		</tbody>
		@for (log of adminLogs; track log) {
			<tbody>
				<tr>
					<td (click)="log.expanded = !log.expanded" class="clickable"><span class="expander-button" [class.expanded]="log.expanded">▸</span></td>
					<td (click)="log.expanded = !log.expanded" class="clickable">{{log.ts | datetime : "date" }}</td>
					<td (click)="log.expanded = !log.expanded" class="clickable">{{log.author_email}}</td>
					<td (click)="log.expanded = !log.expanded" class="clickable truncate" [title]="log.title"><span>{{log.title}}</span></td>
					<td>
						<app-action-button [action]="DeleteLog" [args]="[log.admin_log_id]" [context]="this" title="Delete note" btnClass="icon red" confirm="Delete this note completely?"
							processing="..."><i class="icon-trash"></i></app-action-button>
					</td>
				</tr>
				@if (log.expanded) {
					<tr>
						<td colspan="5" class="log-content">
							<form>
								<div class="mb-3 row">
									<label class="col-md-2">Title:</label>
									<div class="col-md-10">
										<input [(ngModel)]="log.editTitle" name="editTitle" type="text" maxlength="64" class="form-control">
									</div>
								</div>
								<div class="mb-3">
									<div>Details:</div>
									<textarea [(ngModel)]="log.editContent" name="editContent" rows="10" class="form-control"></textarea>
								</div>
								<div class="mb-3 row">
									<div class="col-md-8 offset-md-4">
										<app-action-button submit [action]="SaveLog" [context]="this" [args]="[log]" processing="Saving..." complete="Log saved" btnClass="block">Save
										</app-action-button>
									</div>
								</div>
							</form>
						</td>
					</tr>
				}
			</tbody>
		}
	</table>
}